export type TextEditorProps = {
  placeholder: string;
  maxLength: number;
  content?: string;
  ariaLabel: string;
  boldAriaLabel: string;
  italicAriaLabel: string;
  toolbarOptions: EditorProperties;
  linkErrorMessage: string;
  onChange: (htmlText: string, plainText: string) => void;
};

export type EditorProperties = {
  alignOptions: {
    key: string;
    label: string;
  }[];
  fontStyleOptions: {
    key: string;
    label: string;
  }[];
  linkOptions: {
    title: string;
    pathLabel: string;
    placeholder: string;
    ariaLabel: string;
    cancelLabel: string;
    submitLabel: string;
  };
  fontColors: string[];
  backgroundColors: string[];
};

export enum TextAlignOptions {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum FontStyleOptions {
  PARAGRAPH = 'p',
  HEADING3 = 'h3',
  HEADING4 = 'h4',
}

export type ColorPanelProps = {
  selectedColor: string;
  fontColor: boolean;
  colorsList: string[];
};
